import { Magic } from 'magic-sdk';

let setMagicReady;
const magicReady = new Promise(resolve => (setMagicReady = resolve));

const init = async apiKey => {
    const magic = new Magic(apiKey);

    if (await magic.user.isLoggedIn()) {
        await magic.user.logout();
    }

    setMagicReady(magic);
};

export default {
    init,
    getInstance: () => magicReady,
};
